import { render, staticRenderFns } from "./HostOnboardingFeedbacks.vue?vue&type=template&id=3cdde07b&scoped=true&"
import script from "./HostOnboardingFeedbacks.vue?vue&type=script&lang=js&"
export * from "./HostOnboardingFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./HostOnboardingFeedbacks.vue?vue&type=style&index=0&id=3cdde07b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdde07b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VIcon,VRow})
